import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { ApiError } from '@/lib/api';
import { googleDugmesiCiz } from '@/lib/google';
import { Card, Spinner } from '@/components/ui';

/**
 * Giriş — yalnız Google.
 *
 * Parola alanı ve kayıt formu kaldırıldı: kimsenin parolasını saklamak
 * zorunda değiliz ve kampa katılan herkesin zaten bir Google hesabı
 * var. Daha önce parolayla açılmış hesaplar E-POSTA ile eşleşiyor,
 * yani aynı adresle girildiğinde eski kayıt olduğu gibi açılıyor.
 */
export function LoginPage() {
  const { googleIleGir } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/dashboard';

  const kap = useRef<HTMLDivElement>(null);
  const [hata, setHata] = useState('');
  const [bekliyor, setBekliyor] = useState(false);

  useEffect(() => {
    let birakildi = false;

    (async () => {
      try {
        if (!kap.current) return;
        await googleDugmesiCiz(kap.current, async (credential) => {
          if (birakildi) return;
          setHata('');
          setBekliyor(true);
          try {
            await googleIleGir(credential);
            navigate(redirect, { replace: true });
          } catch (err) {
            setHata(err instanceof ApiError ? err.message : 'Giriş yapılamadı');
          } finally {
            if (!birakildi) setBekliyor(false);
          }
        });
      } catch (_) {
        setHata('Google giriş penceresi açılamadı. Bağlantınızı denetleyip sayfayı yenileyin.');
      }
    })();

    return () => {
      birakildi = true;
    };
  }, [googleIleGir, navigate, redirect]);

  return (
    <Card>
      <h2 className="font-serif mb-1 text-xl font-semibold">Giriş</h2>
      <p className="mb-5 text-sm text-muted-foreground">
        Google hesabınızla girin. Ayrıca bir parola oluşturmanız gerekmiyor.
      </p>

      <div className="flex min-h-[44px] justify-center" ref={kap} />

      {bekliyor && (
        <p className="mt-4 flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Spinner /> Giriş yapılıyor…
        </p>
      )}

      {hata && <p className="mt-4 text-center text-sm text-destructive">{hata}</p>}

      <p className="mt-6 text-center text-xs leading-relaxed text-muted-foreground">
        İlk defa giriyorsanız hesabınız kendiliğinden açılır. Bir kampa katılmak için
        size gönderilen davet bağlantısını kullanın.
      </p>
    </Card>
  );
}
